import React, { useState, useEffect, useContext, useRef, memo } from 'react';
import { useNavigate } from 'react-router-dom';
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import 'react-quill/dist/quill.snow.css';
import Draggable from 'react-draggable';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin, { interactionDraggable } from '@fullcalendar/interaction'; // For drag and drop
import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';

function LeadSchedular({ show, onClose, LeadID, leadAppointments }) {

  const { theme, toggleTheme } = useContext(ThemeContext);
  const calendarRef = useRef(null);
  let accordTheme = theme === "dark" ? "accordion-header-dark" : "accordion-header-light";
  const [Weekened, setWeekened] = useState(true);
  const [calendarView, setCalendarView] = useState('timeGridWeek');
  const [events, setEvents] = useState([]);
  const [slotDuration, setSlotDuration] = useState('01:00:00'); // Default to 1 hour
  const [selectedTeam, setSelectedTeam] = useState(0);
  const computeSlotTimes = () => {
    let slotMinTime = '00:00:00';
    let slotMaxTime = '24:00:00';

    if (calendarView === 'timeGridDay' || calendarView === 'timeGridWeek') {
      // Adjust slotMinTime and slotMaxTime to show the full range if necessary
    }

    return { slotMinTime, slotMaxTime };
  };
  const { slotMinTime, slotMaxTime } = computeSlotTimes();
  const handleStart = (e, ui) => {
    e.stopPropagation();
  }
  useEffect(() => {
    fetchLeadAppointments();
  }, []);
  const fetchLeadAppointments = async () => {

    try {
      const formattedEvents = leadAppointments.map(app => ({
        title: app.vc_Company, // Modify as per your data structure
        start: app.AppointmentDate, // Ensure the time format is compatible with FullCalendar
        end: app.EndDate, // Ensure the time format is compatible with FullCalendar
        backgroundColor: app.Color,
        description: app.Notes,
        ID: app.ID

      }));

      setEvents(formattedEvents); // Update state with the fetched events
    } catch (error) {
      console.error('Error fetching job engineers:', error);
    }
  };
  return (
    <div>
      <form>
        <div className="modal fade leadSchedularModal show d-block" id="leadSchedularModal" tabIndex="-1" aria-labelledby="leadSchedularModalLabel" aria-hidden="true" data-backdrop="static">

          <div className="modal-dialog modal-lg">
            <Draggable handle=".modal-content" onStart={handleStart}
              cancel="input, textarea, select, button, ul,li,table,a,ReactQuill,p">
              <div className="modal-content">
                <div className={`modal-header ${accordTheme}`}>
                  <h5 className="modal-title" id="largeModalLabel">Appointments</h5>
                  <button type="button" className="close" aria-label="Close" onClick={onClose}>
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div className="modal-body">
                  <div className="calendar-container">

                    <FullCalendar
                      ref={calendarRef}
                      plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
                      initialView={calendarView}
                      editable={true}
                      events={events}
                      slotDuration={slotDuration}
                      slotMinTime={slotMinTime}
                      slotMaxTime={slotMaxTime}
                      scrollTime="08:00:00"
                      slotLabelInterval={slotDuration}
                      key={calendarView}
                      droppable={true}
                      weekends={Weekened}
                      buttonText={{
                        today: 'Today',
                      }}
                      longPressDelay={1000}
                      allDaySlot={false}
                      eventDidMount={(info) => {
                        tippy(info.el, {
                          content: info.event.extendedProps.description || "No description provided",
                          allowHTML: true,
                          theme: "light",
                        });
                      }}
                    />

                  </div>


                </div>
                <div className="modal-footer">

                  <button className="btn btn-secondary" type="button" aria-label="Close" onClick={onClose}>
                    <i className="icofont-close" aria-hidden="true"> Close</i>
                  </button>
                </div>
              </div>
            </Draggable>
          </div>
        </div >
      </form >
    </div >
  );
}
export default LeadSchedular;
